module.exports = __webpack_public_path__ + "img/TRST.e3e6c26e.svg";